import * as React from "react";
const SvgFiRrSpringCalendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-spring-calendar_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-1V1a1 1 0 1 0-2 0v1H8V1a1 1 0 1 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5M5 4h14c1.654 0 3 1.346 3 3v1H2V7c0-1.654 1.346-3 3-3m14 18H5c-1.654 0-3-1.346-3-3v-9h9.942a.97.97 0 0 0-.672.312c-.526.583-1.142 1.483-1.142 2.492 0 .055.007.109.011.164-.854-.466-1.9-.396-2.647-.247a.99.99 0 0 0-.739 1.272c.204.643.573 1.457 1.222 1.997-.649.54-1.018 1.354-1.222 1.997a.99.99 0 0 0 .739 1.272c.747.149 1.793.219 2.647-.247-.003.053-.01.105-.01.159 0 1.009.617 1.909 1.142 2.492a.987.987 0 0 0 1.462 0c.526-.583 1.142-1.483 1.142-2.492 0-.047-.006-.093-.009-.139.854.465 1.899.395 2.646.246a.99.99 0 0 0 .739-1.273c-.205-.647-.577-1.466-1.233-2.006.656-.54 1.028-1.359 1.233-2.006a.99.99 0 0 0-.739-1.273c-.747-.149-1.793-.22-2.647.247.004-.055.011-.108.011-.164 0-1.009-.617-1.909-1.142-2.492a.97.97 0 0 0-.672-.312h9.942v9c0 1.654-1.346 3-3 3zm-7-7.5a1.498 1.498 0 1 1 0 2.996 1.498 1.498 0 0 1 0-2.996"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-spring-calendar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpringCalendar;
